import { creditAppReducer, CreditAppRoot, CREDIT_ROOT_ROUTE, routes } from '@makemydeal/activities-credit-app';
import { creditAppMiddleware } from './middleware';

// Credit App configuration following Trade-In activity pattern
export const creditAppConfiguration = {
    middleware: creditAppMiddleware,
    reducer: creditAppReducer,
    defaultRoute: CREDIT_ROOT_ROUTE,
    routes: Object.values(routes),
    routingComponent: CreditAppRoot
};
